import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { BalanceModalPage } from './balance-modal';

@NgModule({
  declarations: [
    BalanceModalPage,
  ],
  imports: [
    IonicPageModule.forChild(BalanceModalPage),
  ],
})
export class BalanceModalPageModule {}



// WEBPACK FOOTER //
// ./src/app/shared/balance-modal/balance-modal.module.ts